import { Pipe, PipeTransform } from '@angular/core';
import { IOption } from '@shared/select/option.interface';

// NOTE: F5 этапа 1 - у записи выбрана ставка вида, которого нет в стране проекта: показать предупреждение под полем
@Pipe({
  name: 'isLegacyVatRate',
  standalone: true,
})
export class IsLegacyVatRatePipe implements PipeTransform {
  transform(rates: IOption[] | null | undefined, current: number | null | undefined): boolean {
    return (rates ?? []).some((option: IOption) => !!option.legacy && option.id === current);
  }
}
